import DOMPurify from "dompurify";

const sanitizeText = (value: string) =>
    DOMPurify.sanitize(value, {
        ALLOWED_TAGS: [],
        ALLOWED_ATTR: [],
    });

export const sanitizePayload = <T>(payload: T): T => {
    if (payload === null || payload === undefined) return payload;

    if (typeof payload === "string") {
        return sanitizeText(payload) as T;
    }

    if (Array.isArray(payload)) {
        return payload.map(item => sanitizePayload(item)) as T;
    }

    if (typeof payload === "object") {
        const cleanObj: any = {};
        for (const key in payload) {
            cleanObj[key] = sanitizePayload((payload as any)[key]);
        }
        return cleanObj;
    }

    return payload;
};